import 'reflect-metadata';
import { deserealizeTokenWithPriceAndMetadataAndAmount } from '../../SmartDB/Commons/conversions';
import { asSmartDBEntity, Convertible, type Token_With_Price_And_Date_And_Signature_And_Amount_And_Metadata } from '../Commons/index';
import { FundEntity } from './Fund.Entity';
import { FundHoldingEntity } from './Fund.Holding.Entity';
import { InvestUnitWithDetailsEntity } from './Invest.Unit.WithDetails.Entity';

@asSmartDBEntity()
export class FundWithDetailsEntity extends FundEntity {
    protected static _apiRoute: string = 'funds-with-details';
    protected static _className: string = 'Fund With Details';
    // protected static _mongoTableName: string = 'Fund';

    // #region fields

    @Convertible({
        propertyToFill: 'investUnit',
        relation: 'OneToOne',
        typeRelation: InvestUnitWithDetailsEntity,
        cascadeSave: false,
        cascadeLoad: true,
        optionsGet: { doCallbackAfterLoad: true, loadRelations: {} },
    })
    investUnit_id!: string;
    investUnit!: InvestUnitWithDetailsEntity | undefined;

    @Convertible({
        propertyToFill: 'fundHoldings',
        relation: 'OneToMany',
        typeRelation: FundHoldingEntity,
        cascadeSave: false,
        cascadeLoad: true,
        optionsGet: { loadRelations: {} },
    })
    fundHoldings_ids!: string[];
    fundHoldings!: FundHoldingEntity[];

    @Convertible({ fromPlainObject: deserealizeTokenWithPriceAndMetadataAndAmount })
    tokenFT?: Token_With_Price_And_Date_And_Signature_And_Amount_And_Metadata;

    // #endregion fields

    // #region db

    public static alwaysFieldsForCallbackOnAfterLoad: Record<string, boolean> = {
        ...super.alwaysFieldsForCallbackOnAfterLoad,
        total_FT_Minted: true,
        priceADAx1e6: true,
        TVLx1e6: true,
        change24: true,
        feeEarned: true,
        staked: true,
    };

    // #endregion db
}
